var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCommentFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5C4.937 2.5.833 5.79.833 9.851c0 1.753.767 3.358 2.041 4.62C2.427 16.25.93 17.838.912 17.855a.278.278 0 0 0-.054.308.28.28 0 0 0 .262.17c2.374 0 4.153-1.125 5.034-1.817 1.171.434 2.471.685 3.846.685 5.063 0 9.167-3.29 9.167-7.35C19.167 5.79 15.063 2.5 10 2.5z",
    fill: "#B6E0FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommentFilled);
export default __webpack_public_path__ + "static/media/icon-comment-filled.663989cf.svg";
export { ForwardRef as ReactComponent };